import React from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../themes/store/hooks/useStore';

export default function PublicStoreRoute({ children }: { children: React.ReactNode }) {
  const { settings, loading, error } = useStore();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#C5D86D]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-[#0F172A] mb-4">Loja não encontrada</h1>
          <p className="text-gray-600">
            Desculpe, não conseguimos encontrar a loja que você está procurando.
          </p>
        </div>
      </div>
    );
  }

  if (!settings) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-[#0F172A] mb-4">Loja indisponível</h1>
          <p className="text-gray-600">
            Esta loja não está disponível no momento. Por favor, tente novamente mais tarde.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
